function translateRestriction(restriction, translateFunc) {
    if (typeof translateFunc !== 'function')
        return null;

    switch(restriction) {
        case 0: return translateFunc("PropertyCz.Report.OD.Restriction.No");
        case 1: return translateFunc("PropertyCz.Report.OD.Restriction.LessSerious");
        case 2: return translateFunc("PropertyCz.Report.OD.Restriction.Serious");
        default: return null;
    }
}

function formatObligedPerson(op, subjectIdLabel, prefixLabel = null) {
    if (op === undefined || op === null)
        return null;

    if (isNullOrEmpty(op.firstName) && isNullOrEmpty(op.lastName) && isNullOrEmpty(op.street) && isNullOrEmpty(op.streetNumber) &&
        isNullOrEmpty(op.streetNumberDescriptive) && isNullOrEmpty(op.municipality) && isNullOrEmpty(op.zipCode) &&
        isNullOrEmpty(op.subjectName) && isNullOrEmpty(op.companyId))
        return null;

    let ret;
    const snDesc = isNullOrEmpty(op.streetNumberDescriptive) ? "" : `/${op.streetNumberDescriptive}`;
    if (isNullOrEmpty(op.companyId)) {
        const name1 = isNullOrEmpty(op.firstName) && isNullOrEmpty(op.lastName) ? op.subjectName : `${op.firstName} ${op.lastName}`;
        ret = `${name1}, ${op.street} ${op.streetNumber}${snDesc}, ${op.zipCode} ${op.municipality}`;
    } else {
        const name2 = isNullOrEmpty(op.subjectName) ? `${op.firstName} ${op.lastName}` : op.subjectName;
        const addr = isNullOrEmpty(op.street) ? op.municipality : op.street;
        ret = `${name2}, ${subjectIdLabel} = ${op.companyId}, ${addr} ${op.streetNumber}${snDesc}, ${op.zipCode} ${op.municipality}`;
    }

    return isNullOrEmpty(prefixLabel) ? ret : `${prefixLabel}: ${ret}`;
}

function isNullOrEmpty(s) {
    return s === undefined || s === null || typeof s !== 'string' || s.length === 0;
}

export { translateRestriction, formatObligedPerson };
